<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Liquidación de Aportes - Listar</strong>
          </CCardHeader>
          <CCardBody>
            <b-row>
         

              <b-col sm="12" md="5">
                  <b-form-group>
                    <label>Socio: </label>
                    <v-select @input="ListSettlementContribution" placeholder="Todos" class="w-100" :filterable="false" label="full_name" v-model="partner" @search="SearchPartnes" :options="partners"></v-select>
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="2">
                  <b-form-group label="Desde :">
                    <b-form-input @change="ListSettlementContribution" class="text-center" :max="to" type="date"  ref="to" v-model="from"></b-form-input>
                    <small v-if="errors.from" class="form-text text-danger" >Seleccione una fecha</small>
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="2">
                  <b-form-group label="Hasta :">
                    <b-form-input @change="ListSettlementContribution" class="text-center" :min="from" type="date"  ref="from" v-model="to"></b-form-input>
                    <small v-if="errors.to" class="form-text text-danger" >Seleccione una fecha</small>
                  </b-form-group>
                </b-col>

                
                <b-col sm="6" md="2">
                  <b-form-group label=".">
                    <b-input-group>
                    <b-form-input @keyup.enter="ListSettlementContribution" v-model="search" class="form-control"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" @click="ListSettlementContribution"><b-icon icon="search"></b-icon></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col sm="6" md="1">
                  <b-form-group label=".">
                    <b-link  v-if="Permission('SettlementContributionAdd')" class="btn form-control btn-primary"  :to="{ path: '/liquidacion-aporte/nuevo' }" append ><i class="fas fa-file"></i></b-link>
                  </b-form-group>
                </b-col>
            </b-row>

            <div class="table-responsive mt-3 height-table">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="3%" class="text-center">#</th>
                    <th width="8%" class="text-center">Fecha</th>
                    <th width="50%" class="text-center">Socio</th>
                    <th width="10%" class="text-center">N° Liquidación</th>
                    <th width="8%" class="text-center">Total</th>
                    <th width="7%" class="text-center">Usuario</th>
                    <th width="7%" class="text-center">Estado</th>
                    <th width="7%" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="it">
                  <tr>
                    <td class="text-center">{{ it + 1 }}</td>
                    <td class="text-center"> {{ item.application_date  }}</td>
                    <td class="text-left"> {{ item.partner_name + " - "+ item.partner_document_number  }}</td>
                    <td class="text-left"> {{ item.number  }}</td>
                    <td class="text-right"> {{ item.total  }}</td>
                    <td class="text-left"> {{ item.user  }}</td>
                    <td class="text-center">
                        <b-badge v-if="item.state == 2" variant="success">Aceptado</b-badge>
                        <b-badge v-if="item.state == 1" variant="warning">Pendiente</b-badge>
                        <b-badge v-if="item.state == 0" variant="danger">Rechazado</b-badge>
                    </td>
                    <td class="text-center">
                      <b-dropdown bloque size="sm" text="Acciones" right>
                        <b-dropdown-item v-if="Permission('SettlementContributionEdit') && item.state == 1" @click="EditSettlementContribution(item.id_settlement_contribution)" >Editar</b-dropdown-item>
                        <b-dropdown-item v-if="Permission('SettlementContributionView')" @click="ViewSettlementContribution(item.id_settlement_contribution)" >Ver</b-dropdown-item>
                        <b-dropdown-item v-if="Permission('SettlementContributionDelete')" @click="ConfirmDeleteSettlementContribution(item.id_settlement_contribution)" >Eliminar</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-row class="mt-4">
              <b-col md="8">
                <b-pagination v-model="currentPage" v-on:input="ListSettlementContribution" :total-rows="rows" :per-page="perPage" align="center" ></b-pagination>
              </b-col>
              <b-col md="4 text-center">
                <p>Pagina Actual: {{ currentPage }}</p>
              </b-col>
            </b-row>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import CodeToName from "@/assets/js/CodeToName";
var moment = require("moment");
export default {
  name: "UsuarioList",
  components:{
    vSelect,
  },
  data() {
    return {
      module:'SettlementContribution',
      perPage: 15,
      currentPage: 1,
      rows: 0,
      data_table: [],
      
      id_partner:'',
      to:moment(new Date()).local().format("YYYY-MM-DD"),
      from:moment().subtract(30, 'days').local().format("YYYY-MM-DD"),
      search: "",
      partners: [],
      partner:null,
      errors:{
        to:false,
        from:false,
      }
    };
  },
  mounted() {
    this.ListSettlementContribution();
  },
  methods: {
    ListSettlementContribution,
    EditSettlementContribution,
    ViewSettlementContribution,
    ConfirmDeleteSettlementContribution,
    DeleteSettlementContribution,
    Permission,

    SearchPartnes,
    NameTwistType,
    NameMethodPayment,


  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};



function NameMethodPayment(code) {
return CodeToName.NameMethodPayment(code);
}

function NameTwistType(code) {
  let name = '';
  switch (code) {
    case '1': name = 'Sepelio'; break;
    case '2': name = 'Liquidación de Aportes'; break;
    case '3': name = 'Gasto Administrativo'; break;
    case '4': name = 'Prestamo Ordinario'; break;
  }
  return name;
}

function SearchPartnes(search, loading) {
  
   let me = this;
    let url = this.url_base + "search-partner/" + search;
    if (search !== "") {
      loading(true);
      axios({
        method: "GET",
        url: url,
      }).then(function (response) {
            me.partners = response.data;
            loading(false);
      })
    }
}

function ListSettlementContribution() {
  this.errors.from = false;
  this.errors.to = false;

  let id_partner = this.partner == null ? 'all' : this.partner.id;
  if (this.from.length == 0) {this.errors.from = true; return false;}
  if (this.to.length == 0) {this.errors.to = true; return false;}
  let search = this.search == "" ? "all" : this.search;

  let me = this;
  let url = this.url_base + "settlement-contribution/list/" + id_partner + "/" + this.from + "/" + this.to + "/" + search + "?page=" + this.currentPage;

  axios({
    method: "GET",
    url: url,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.total;
        me.data_table = response.data.result.data;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// Editar usuario
function EditSettlementContribution(id_settlement_contribution) {
  this.$router.push({
    name: "SettlementContributionEdit",
    params: { id_settlement_contribution: je.encrypt(id_settlement_contribution) },
  });
}

// Ver Usuario
function ViewSettlementContribution(id_settlement_contribution) {
  this.$router.push({
    name: "SettlementContributionView",
    params: { id_settlement_contribution: je.encrypt(id_settlement_contribution) },
  });
}

// Confirmar eliminar
function ConfirmDeleteSettlementContribution(id_settlement_contribution) {
  Swal.fire({
    title: "Esta seguro de eliminar la liquidación de aporte?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeleteSettlementContribution(id_settlement_contribution);
    }
  });
}

// eliminar usuario
function DeleteSettlementContribution(id_settlement_contribution) {
  let me = this;
  let url = this.url_base + "settlement-contribution/delete/" + id_settlement_contribution;
  axios({
    method: "delete",
    url: url,
    headers: {token: this.token, module: this.module,role: 4,},
  })
    .then(function (response) {
       if (response.data.status == 200) {
        const index = me.data_table.map(item => item.id_settlement_contribution).indexOf(response.data.result.id_settlement_contribution);
        me.data_table.splice(index, 1);
        Swal.fire({ icon: 'success', text: response.data.message, timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>
